import { gql } from '@apollo/client'

// TODO(phase 2): add `needs_help` once the column exists on live_call_state (see /memories/session/plan.md)
export default gql`
  subscription GetLiveMonitorCallStates($readingIds: [uuid!]!) {
    live_call_state(where: { reading_id: { _in: $readingIds } }) {
      reading_id
      user_id
      personName
      role
      is_hand_raised
      last_updated
      agora_connected
      mic_status
      camera_status
      network_quality_up
      network_quality_down
      send_bitrate_kbps
      recv_bitrate_kbps
      rtt_ms
      status_updated_at
    }
  }
`
